(function () {
  "use strict";

  /**
   * Format cents using theme money helpers when available.
   */
  const formatMoney = function (cents) {
    if (cents == null || isNaN(cents)) return "";
    const fmt =
      (window.themeCore &&
        window.themeCore.objects &&
        window.themeCore.objects.shop &&
        window.themeCore.objects.shop.money_format) ||
      (window.Shopify && window.Shopify.money_format) ||
      "${{amount}}";

    if (
      window.themeCore &&
      window.themeCore.utils &&
      typeof window.themeCore.utils.formatMoney === "function"
    ) {
      return window.themeCore.utils.formatMoney(cents, fmt);
    }

    const amount = (Number(cents) / 100).toFixed(2).replace(/\.00$/, "");
    return fmt
      .replace("{{amount}}", amount)
      .replace("{{amount_no_decimals}}", String(Math.round(Number(cents) / 100)));
  };

  /**
   * OTP restore must use the *current* variant base price — not page-load cache.
   * product-price-restore.js is the canonical implementation; this mirrors it
   * when that script is not present yet, and defers to window.restorePrice if set.
   */
  const initPriceRestoration = function () {
    if (typeof window.restorePrice === "function") return;

    const getProductJson = function () {
      const el = document.querySelector("[data-js-product-json]");
      if (!el) return null;
      try {
        return JSON.parse(el.textContent || "{}");
      } catch (e) {
        return null;
      }
    };

    const getCurrentVariantId = function () {
      const root = document.querySelector("[data-js-product-container]") || document;
      const input = root.querySelector('[name="id"]');
      if (!input || !input.value) return null;
      const id = parseInt(input.value, 10);
      return isNaN(id) ? null : id;
    };

    const findVariant = function (product, variantId) {
      if (!product) return null;
      if (variantId && product.variants) {
        for (let i = 0; i < product.variants.length; i++) {
          if (product.variants[i].id === variantId) return product.variants[i];
        }
      }
      return (
        product.selected_or_first_available_variant ||
        (product.variants && product.variants[0]) ||
        null
      );
    };

    window.restorePrice = function () {
      const product = getProductJson();
      const variant = findVariant(product, getCurrentVariantId());
      if (!variant || variant.price == null) return;

      const price = variant.price;
      const compare = variant.compare_at_price;
      const onSale = compare != null && compare > price;
      const moneyPrice = formatMoney(price);
      const moneyCompare = compare != null ? formatMoney(compare) : "";

      document.querySelectorAll("[data-product-price]").forEach(function (el) {
        el.innerHTML = moneyPrice;
        el.setAttribute("data-amount", String(price));
      });
      document.querySelectorAll("[data-price-old]").forEach(function (el) {
        el.innerHTML = moneyCompare;
        if (compare != null) el.setAttribute("data-amount", String(compare));
      });
      document.querySelectorAll(".js-price").forEach(function (el) {
        el.classList.toggle("price--on-sale", onSale);
      });
    };
  };

  const initSellingPlanManagement = function () {
    document.querySelectorAll('[name="selling_plan"]').forEach(function (sp) {
      if (sp._spBound) return;
      // Radios are managed by the Subscriptions app; only sync hidden inputs
      if (sp.type === "radio" || sp.type === "checkbox") return;
      sp._spBound = true;
      const updateSpDisabled = function () {
        if (sp.value && String(sp.value).length) {
          sp.disabled = false;
          sp.removeAttribute("disabled");
        } else {
          sp.disabled = true;
        }
      };
      updateSpDisabled();
      sp.addEventListener("change", updateSpDisabled);
      sp.addEventListener("input", updateSpDisabled);
      // App often sets .value without events
      let last = sp.value;
      sp._spPoll = setInterval(function () {
        if (!document.contains(sp)) {
          clearInterval(sp._spPoll);
          return;
        }
        if (sp.value !== last) {
          last = sp.value;
          updateSpDisabled();
        }
      }, 250);
    });
  };

  const initOtpListeners = function () {
    const otpInputs = document.querySelectorAll('[id^="tab_otp_"]');
    otpInputs.forEach(function (input) {
      if (input._otpBound) return;
      input._otpBound = true;
      input.addEventListener("change", function () {
        if (input.type === "radio" && !input.checked) return;
        if (typeof window.restorePrice === "function") window.restorePrice();
      });
    });
  };

  const init = function () {
    document.documentElement.classList.remove("no-js");

    initPriceRestoration();
    initSellingPlanManagement();
    initOtpListeners();

    // Late-injected subscription widget (Shopify Subscriptions app)
    if (document.body) {
      const mo = new MutationObserver(function () {
        // product-price-restore may have replaced restorePrice — keep listeners
        if (typeof window.restorePrice !== "function") initPriceRestoration();
        initSellingPlanManagement();
        initOtpListeners();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }

    window.themeMoneyFormat = formatMoney;
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
